module.exports = __webpack_public_path__ + "static/media/windelrocker2.c1347287.jpg";